export default "__VITE_ASSET__BtqE7$h___"